module.exports = __webpack_public_path__ + "static/media/logo.9f52f00f.png";